import { Injectable, EventEmitter } from '@angular/core';
import {
  AsyncValidatorFn,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import {
  BaseFpxDataService,
  CreateFn,
  FindAllFn,
  FindByKeyFn,
  HttpRequest,
  LookUpFn,
  ModifyFn,
  CriteriaQuery,
  HttpProviderService
} from '@fpx/core';
import { IHttpSuccessPayload,ILookupResponse } from '@fpx/core';
import { add } from '@amcharts/amcharts4/.internal/core/utils/Array';
import { map, Observable, of } from 'rxjs';
import { Casatransaction, CasatransactionMaintanence } from './casatransaction.model';
import { environment } from 'src/environments/environment';
import moment from 'moment';
import { CommonService } from 'src/app/common.service';
import { API_DATE_FORMAT } from '@common/constants';
@Injectable()
export class CasatransactionService implements BaseFpxDataService<any> {
  eventEmit: EventEmitter<any>;
  currentCriteriaQuery: any
 constructor(private _httpProvider : HttpProviderService,private _commonservice : CommonService) {
  // this.eventEmit = new EventEmitter();
  //   this.eventEmit.subscribe((x) => {
  //     this.findAll(x);
  //   });
 }

 findByKey(key: Casatransaction): FindByKeyFn<Casatransaction> {
  return () => {
    const httpRequest = new HttpRequest();
    //criteriaq query
    const criteriaQuery=new CriteriaQuery();
    httpRequest.setResource('/casatransaction/{accountNumber}');
    //  httpRequest.addQueryParameter('accountNumber', '510053501000');
     //add query param
    // httpRequest.addQueryParameter("fromDate", 2022- 4 -15);
    // httpRequest.addQueryParameter("toDate", 2022- 5 - 24);
    httpRequest.setCriteriaQuery(criteriaQuery);
    httpRequest.setMethod('GET');
    httpRequest.setServerContext(environment.accountsPublisher);
    return this._httpProvider
      .invokeRestApi(httpRequest)
      .pipe(map((res: IHttpSuccessPayload<any>) => res.body?.casatransaction ?? null));
  };
}
  findAll(criteriaQuery: CriteriaQuery): FindAllFn<any> {
    return () => {
      criteriaQuery.addSortCriteria('transactionDate','desc','Date');
      if (criteriaQuery.getQueryparam('fileType')=='VOS') {
        return this.createFilter(criteriaQuery).pipe(
         map(
           (res: any) =>
             res?.body?.casatransaction?.casatransactiondtls
         )
       );
       }else{
        criteriaQuery.addSortCriteria('transactionDate','desc','Date');
        let accountNumber = criteriaQuery.getQueryparam('accountNumber');
        let fromDate = criteriaQuery.getQueryparam('fromDate');
        let toDate = criteriaQuery.getQueryparam('toDate');
        let statementType = criteriaQuery.getQueryparam('statementType');
        const httpRequest = new HttpRequest();
        httpRequest.setResource('/casatransaction');
        httpRequest.addQueryParameter('accountNumber', accountNumber);
        httpRequest.addQueryParameter("fromDate", fromDate);
        httpRequest.addQueryParameter("toDate", moment().format(API_DATE_FORMAT)===toDate?this._commonservice.serverDate:toDate);
        httpRequest.addQueryParameter("statementType", statementType);
        httpRequest.setMethod('GET');
        httpRequest.setServerContext(environment.accountsPublisher);
        httpRequest.setCriteriaQuery(criteriaQuery);

        this.currentCriteriaQuery = {
          "criteriaDetails": {
              "offset": "1",
              "Count": "20",
              "OrderCriteria": [
                  {
                      "columnName": "transactionDate",
                      "orderType": "asc",
                      "columnType": "String"
                  }
              ]
          }
      };

        return this._httpProvider
          .invokeRestApi(httpRequest)
          .pipe(map((res: IHttpSuccessPayload<any>) => res.body?.casatransaction?.casatransactiondtls ?? null));
      };
    }
  }



  createFilter(criteriaQuery: any):Observable<Casatransaction[]>{

    const httpRequest = new HttpRequest();
    httpRequest.setMethod('POST');
    httpRequest.setResource('/casatransaction/query');
    httpRequest.setServerContext(environment.accountsPublisher);
    let accountNumber = criteriaQuery.getQueryparam('accountNumber');
    let fromDate = criteriaQuery.getQueryparam('fromDate');
    let toDate = criteriaQuery.getQueryparam('toDate');
    let transactionPeriod = criteriaQuery.getQueryparam('transactionPeriod');
    httpRequest.addQueryParameter('accountNumber',accountNumber)
    let bodyContent;
      if(transactionPeriod!='0'){
         bodyContent={
          "criteriaDetails": {
            "FilterExpression": "C1",
            "FilterCriteria": [
                {
                    "columnName": "transactionDate",
                    "columnType": "Date",
                    "conditions": {
                        "searchType": "inRange",
                        "dateFrom": fromDate,
                        "dateTo": moment().format(API_DATE_FORMAT)===toDate?this._commonservice.serverDate:toDate
                    }
                }
            ]
        }

      }

      }else{
        bodyContent=  {

            "criteriaDetails": {
                "offset": "1",
                "Count": "20",
                "OrderCriteria": [
                    {
                        "columnName": "transactionDate",
                        "orderType": "asc",
                        "columnType": "String"
                    }
                ]
            }
        }
      }
    httpRequest.setBody(bodyContent);

    this.currentCriteriaQuery = bodyContent;
    return this._httpProvider.invokeRestApi(httpRequest);

  }
  lookup(key: unknown): LookUpFn<any> {
    throw new Error('Method not implemented.');
  }
  create(payload: Casatransaction): CreateFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('POST');
      httpRequest.setResource('/casatransaction');
      let bodyContent = {"casatransaction":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest);
    // return of(payload)
    };
  }



  modify(payload: Casatransaction): ModifyFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/casatransaction');
       httpRequest.addQueryParameter('accountNumber', payload.accountNumber);
     httpRequest.setMethod('PUT');
      let bodyContent = {"casatransaction":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest);
    };
  }



}
